import React, { useContext, createContext, useState, useEffect } from "react";

export interface WindowSize {
	width: number;
	height: number;
}

interface Props {
	children: JSX.Element;
	isNative: boolean;
}

const WindowSizeContext = createContext(getWindowSize());

function getWindowSize(): WindowSize {
	return {
		width: window.innerWidth,
		height: window.innerHeight,
	};
}

export const WindowSizeProvider = (props: Props) => {
	const [windowSize, setWindowSize] = useState(getWindowSize);

	useEffect(() => {
		function handleResize() {
			setTimeout(() => setWindowSize(getWindowSize()));
		}

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<WindowSizeContext.Provider value={windowSize}>
			{props.children}
		</WindowSizeContext.Provider>
	);
};

export function useWindowSize() {
	return useContext(WindowSizeContext);
}
